import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },

  theme: {
    dark: false,
    themes: {
      light: {
        "primary": "#29b0ce",
        "secondary": "#0d3640"
      },
      dark: {
        "primary": "#29b0ce",
        "secondary": "#0d3640"
      },
    }
  }

});
